import axios from "axios";
import React, { useEffect, useState } from "react";
import { Global } from "../../Variables/Global";
import { forEach } from "lodash-es";
import { FiPlus } from 'react-icons/fi';
import { getDecodedToken } from '../../utils/utils';
import DataTable, { Alignment } from "react-data-table-component";
import axiosInstance from '../../api/axiosConfig';
import DynamicChart from './DynamicChart';



const Dashboard = () => {
    const [ordersCount, setOrdersCount] = useState(0);
    const [productsSoldCount, setProductsSoldCount] = useState(0);
    const [topProfitableClients, setTopProfitableClients] = useState([]);
    const [chartData1, setChartData1] = useState([{ label: 'test', value: 4 }]);
    const [chartData2, setChartData2] = useState([]);
    const GetDashboardReports = () => {
        // if(chartData1.length  > 1) return;
        var config = {
            method: 'get',
            url: 'Reports/GetDashboardReports/' + localStorage.getItem("C0m8N!"),
            headers: {
                'Content-Type': 'application/json'
            },
        };

        axiosInstance(config)
            .then(function (response) {
                // setCurrenciesProfits(response.data);
                setOrdersCount(response.data.ordersCount);
                setProductsSoldCount(response.data.productsSoldCount);
                setTopProfitableClients(response.data.topProfitableClients);

                const arr1 = response.data.topProfitableClients[0].chartData;
                const colors1 = response.data.topProfitableClients[0].chartColors;
                const total1 = response.data.topProfitableClients[0].totalCurrencyProfit;
                const arr2 = response.data.topProfitableClients[1].chartData;
                const colors2 = response.data.topProfitableClients[1].chartColors;
                const total2 = response.data.topProfitableClients[1].totalCurrencyProfit;

                const el1 = document.getElementById('myfirstchart1');
                if (el1.classList.contains('init')) {
                    return;
                }

                window.Morris.Donut({
                    element: el1,
                    data: arr1,
                    colors: colors1,//['#87d6c6', '#54cdb4','#1ab394', '#54cdb4','#1ab394', '#54cdb4','#1ab394'],
                    formatter: function (value, data) {
                        if (total1 != null) {
                            return (value * 100 / total1).toFixed(2) + "%";
                        } else {
                            return value.toLocaleString();
                        }
                    },
                });

                el1.classList.add('init');

                const el2 = document.getElementById('myfirstchart2');
                if (el2.classList.contains('init')) {
                    return;
                }

                window.Morris.Donut({
                    element: el2,
                    data: arr2,
                    colors: colors2,//['#87d6c6', '#54cdb4','#1ab394', '#54cdb4','#1ab394', '#54cdb4','#1ab394'],
                    formatter: function (value, data) {
                        if (total2 != null) {
                            return (value * 100 / total2).toFixed(2) + "%";
                        } else {
                            return value.toLocaleString();
                        }
                    },
                });

                el2.classList.add('init');
                response.data.topProfitableClients[1].chartData.array.forEach(element => {
                    chartData2.push(element);
                });

                setChartData2(response.data.topProfitableClients[1].chartData);
                console.log(chartData1);
                // if(response.data.length > 0){
                //     setShowProfitForCurrency(response.data[0].currencyId);
                // }



                reloadReports();
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    const arrivingSoonColumns = [
        {
            // name: <FiAnchor /> ,
            name: 'Shipment Status',
            selector: row => {
                if (row.statusId == 20) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#292b2c', backgroundColor: '#e9eaea', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 30) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#292b2c', backgroundColor: '#d3d5d6', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 35) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#41b6d9', backgroundColor: '#eff9fc', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 40) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#936b16', backgroundColor: '#fdf0d3', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 45) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#35834f', backgroundColor: '#def8e6', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 50) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#197088', backgroundColor: '#d4f1f9', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
                if (row.statusId == 60) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.blReferenceNo}</b></span>
                                <br />
                                <span style={{ color: '#197088', backgroundColor: '#d4f1f9', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>{row.status}</b></span>
                            </div>
                        </>
                    )
                }
            },
        },
        {
            name: 'POD',
            selector: row => {
                return (
                    <>
                        <div>
                            <span>{row.pod}</span>
                            <br />
                            <span><b>{row.arrivalDate}</b></span>
                        </div>
                    </>
                )
            },
        },
        {
            name: 'Invoice Status',
            selector: row => {
                if (row.remainingTotal == 0.0) {
                    return (
                        <>
                            <div>
                                <span><b>#{row.clientCommercialInvoice}</b></span>
                                <br />
                                <span style={{ color: '#35834f', backgroundColor: '#def8e6', borderColor: '#cdf4da', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>Payment Settled</b></span>
                            </div>
                        </>
                    )
                }
                else {
                    return (
                        <>
                            <div>
                                <span><b>#{row.clientCommercialInvoice}</b></span>
                                <br />
                                <span style={{ color: '#8e3241', backgroundColor: '#fbdde2', borderColor: '#f9cbd3', borderRadius: 5, paddingLeft: 5, paddingRight: 5 }}><b>Payment Required</b></span>
                            </div>
                        </>
                    )
                }
            },
        }
    ];

    const topProductsColumns = [
        {
            name: 'Product',
            selector: row => {
                return (
                    <>
                        <span>{row.productName}</span>
                    </>
                )
            },
        },
        {
            name: 'Quantity Sold',
            selector: row => {
                return (
                    <>
                        <span>{row.productQuantity.toLocaleString()}</span>
                    </>
                )
            },
        },
        {
            name: 'Avg. Sell Price',
            selector: row => {
                return (
                    <>
                        <span>{(row.customerPrice / row.productQuantity).toLocaleString()}</span>
                    </>
                )
            },
        },
        {
            name: 'Avg. Buy Price',
            selector: row => {
                return (
                    <>
                        <span>{(row.supplierPrice / row.productQuantity).toLocaleString()}</span>
                    </>
                )
            },
        },
        {
            name: 'Profit',
            selector: row => {
                return (
                    <>
                        <span>{row.profit.toLocaleString()}</span>
                    </>
                )
            },
        },
    ];

    const [shipments, setShipments] = useState([]);
    const GetShipments = () => {
        var companyId = localStorage.getItem("C0m8N!");
        var config = {
            method: 'get',
            url: "TrackingInfo/GetArrivingShipments",
            headers: {},
            params: { companyId }
        };
        // companyId: localStorage.getItem("C0m8N!")
        axiosInstance(config)
            .then(function (response) {
                setShipments(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const ExportSuppliersDueTable = () => {

        var companyId = localStorage.getItem("C0m8N!");
        const headers = { "Content-Type": "blob" };
        var config = {
            method: 'post',
            url: 'Reports/ExportSuppliersDueTable',
            responseType: "arraybuffer",
            headers,
            params: {
                'CompanyId': companyId
            }
        };

        axiosInstance(config)
            .then(function (response) {
                const outputFilename = `Suppliers Due Table.xlsx`;
                const url = URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", outputFilename);
                document.body.appendChild(link);
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    const [topProducts, setTopProducts] = useState([]);
    const GetTopProductsReport = () => {
        var companyId = localStorage.getItem("C0m8N!");
        var config = {
            method: 'get',
            url: "Reports/GetTopProductsReport/" + companyId,
            headers: {},
        };
        // companyId: localStorage.getItem("C0m8N!")
        axiosInstance(config)
            .then(function (response) {
                setTopProducts(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const reloadReports = () => {
        // const el1 = document.getElementById('myfirstchart1');
        // if (el1.classList.contains('init')) {
        //     return;
        // }

        // window.Morris.Donut({
        //     element: el1,
        //     data: chartData1,
        //     colors: ["#5f76e8", "#01caf1", "#afcaf1"],
        //     // formatter: function (value, data) {
        //     //     return value + "%";
        //     // },
        // });

        // el1.classList.add('init');

        // const el2 = document.getElementById('myfirstchart2');
        // if (el2.classList.contains('init')) {
        //     return;
        // }

        // window.Morris.Donut({
        //     element: el2,
        //     data: chartData2,
        //     colors: ["#5f76e8", "#01caf1", "#afcaf1"],
        //     // formatter: function (value, data) {
        //     //     return value + "%";
        //     // },
        // });

        // el2.classList.add('init');
    }

    const [permissions, setPermissions] = useState([])
    useEffect(() => {
        document.title = "Dashboard"
        // var companyId = localStorage.getItem("C0m8N!");

        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);

        GetDashboardReports();
        GetShipments();
        GetTopProductsReport();
        GetReports();

    }, [])

    const [reports, setReports] = useState([]);

    const GetReports = () => {
        var config = {
            method: 'get',
            url: "Reports/GetReports",
            headers: {},
        };
        axiosInstance(config)
            .then(function (response) {
                setReports(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    return (
        <>
            {permissions != null && permissions.viewDashboard == false ? (
                <>
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h1>You Have No Permission</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </>) : (<>
                    <div class="page-content">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="page-title-box">
                                        <h4>Dashboard</h4>
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><a href="#">Mercator</a></li>
                                            <li class="breadcrumb-item active">Dashboard</li>
                                        </ol>
                                        {/* <button onClick={() => {
                                        ExportSuppliersDueTable();
                                    }
                                    } className="ml-1 btn btn-primary"><FiPlus /> Export Suppliers Due Table</button> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="row">
                                    {reports?.map((report) => (
                                        <div className="col-xl-6 col-sm-6" key={report.reportId}>
                                            {/*<h3>{report.title}</h3>*/}
                                            {/*<p>{report.description}</p>*/}
                                            <DynamicChart report={report} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="footer">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    © <script>document.write(new Date().getFullYear())</script> Lexa <span class="d-none d-sm-inline-block"> - Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand.</span>
                                </div>
                            </div>
                        </div>
                    </footer>
                </>)
            }
        </>
    )

}
export default Dashboard;